exports.components = {
  "component---src-pages-destination-js": () => import("./../../../src/pages/destination.js" /* webpackChunkName: "component---src-pages-destination-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

